module.exports = __webpack_public_path__ + "static/media/databeaver.1f86832a.svg";